/**
 * Legacy storage utilities for non-React code
 * This is the ONLY file allowed to use localStorage directly
 *
 * For React components, use useLegacyStorage hook instead
 *
 * PHASE C FIX: Now delegates to lib/storage.js for org-scoped keys
 */

import { readJSON, writeJSON, removeItem } from '../lib/storage';

/**
 * Get data from storage with vessel scoping
 * PHASE C FIX: Now delegates to lib/storage.js for org-scoped keys
 */
export const legacyGet = (vesselId, key, defaultValue = null) => {
  try {
    const storageKey = vesselId ? `${key}_${vesselId}` : key;
    return readJSON(storageKey, defaultValue);
  } catch (error) {
    console.error('[legacyUtils] legacyGet error:', error);
    return defaultValue;
  }
};

/**
 * Set data to storage with vessel scoping
 * PHASE C FIX: Now delegates to lib/storage.js for org-scoped keys
 */
export const legacySet = (vesselId, key, value) => {
  try {
    const storageKey = vesselId ? `${key}_${vesselId}` : key;
    writeJSON(storageKey, value);
    return true;
  } catch (error) {
    console.error('[legacyUtils] legacySet error:', error);
    return false;
  }
};

/**
 * Remove data from storage
 * PHASE C FIX: Now delegates to lib/storage.js for org-scoped keys
 */
export const legacyRemove = (vesselId, key) => {
  try {
    const storageKey = vesselId ? `${key}_${vesselId}` : key;
    removeItem(storageKey);
    return true;
  } catch (error) {
    console.error('[legacyUtils] legacyRemove error:', error);
    return false;
  }
};

/**
 * Get all keys for a specific vessel
 */
export const legacyGetVesselKeys = (vesselId) => {
  const keys = [];
  const suffix = `_${vesselId}`;
  
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.endsWith(suffix)) {
      keys.push(key);
    }
  }
  
  return keys;
};

/**
 * Familiarisation data helpers
 */
export const getFamiliarisationKey = (crewId) => `familiarisation_completed_${crewId}`;

export const loadFamiliarisationData = (crewId) => {
  try {
    // crew-scoped (not vessel-scoped)
    return readJSON(getFamiliarisationKey(crewId), []);
  } catch (error) {
    console.error('[legacyUtils] loadFamiliarisationData error:', error);
    return [];
  }
};

export const saveFamiliarisationData = (crewId, data) => {
  try {
    // crew-scoped (not vessel-scoped)
    writeJSON(getFamiliarisationKey(crewId), data);
    return true;
  } catch (error) {
    console.error('[legacyUtils] saveFamiliarisationData error:', error);
    return false;
  }
};

/**
 * Pre-departure checklist data helpers
 */
export const getChecklistKey = (voyageId) => `predeparture_checklist_${voyageId}`;

export const loadChecklistData = (voyageId) => {
  try {
    // voyage-scoped (not vessel-scoped)
    return readJSON(getChecklistKey(voyageId), null);
  } catch (error) {
    console.error('[legacyUtils] loadChecklistData error:', error);
    return null;
  }
};

export const saveChecklistData = (voyageId, data) => {
  try {
    // voyage-scoped (not vessel-scoped)
    writeJSON(getChecklistKey(voyageId), data);
    return true;
  } catch (error) {
    console.error('[legacyUtils] saveChecklistData error:', error);
    return false;
  }
};